import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import {
  Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Button, Grid, Paper
} from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import FirmHeaderImg from '../../FieldsComponents/FirmHeaderImg';
import { fetchPOData } from '../../../Store/PHPSlice/Purchase/PoNo';
import { selectPOData } from '../../Selectors/Master/ItemSelectors';

const PurchaseOrdView = () => {
  const { Id } = useParams();
  const dispatch = useDispatch();
  const polist = useSelector(selectPOData);

  const [formData, setFormData] = useState({});
  const componentRef = useRef();

  useEffect(() => {
    dispatch(fetchPOData(Id));
  }, [Id, dispatch]);

  useEffect(() => {
    if (polist?.data) {
      setFormData(polist.data);
    }
  }, [polist]);

  return (
    <Grid item xs={12}>
      <Paper style={{ padding: '15px' }}>

        {/* PRINT AREA */}
        <div ref={componentRef} className="print-container">

          {/* HEADER */}
          <div style={{ textAlign: 'center', marginBottom: '10px' }}>
            {formData?.firmId && <FirmHeaderImg firmId={formData.firmId} />}
            <h2 style={{ margin: '5px 0' }}>Purchase Order</h2>
          </div>

          {/* TOP INFO TABLE */}
          <table style={{ width: '100%', marginBottom: '10px', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td><b>Vendor / Party</b></td>
                <td>{formData.partyNm}</td>
                <td><b>Purchase Order No.</b></td>
                <td>{formData.poNo}</td>
              </tr>
              <tr>
                 <td><b>Vendor / Party Address</b></td>
                <td>{formData.partyAdd}</td>
                <td><b>Date</b></td>
                <td>{formData.date}</td>
               
              </tr>
              <tr>
                <td><b>Vendor / Party GST No</b></td>
                <td>{formData.partygst}</td>
                <td><b>Sub Vendor</b></td>
                <td>{formData.subvendorNm}</td>
              </tr>
              <tr>
                <td><b>Vendor / Party Mobile No</b></td>
                <td>{formData.partycontact}</td>
                <td><b>Sub Vendor Address</b></td>
                <td>{formData.svadrs}</td>
              </tr>
              <tr>
                <td><b>Sub Vendor GST No</b></td>
                <td>{formData.svgst}</td>
                <td><b>Sub Vendor Mobile No</b></td>
                <td>{formData.svcontact}</td>
              </tr>
              <tr>
                <td><b>Shift To</b></td>
                <td>{formData.shiftTo}</td>
                <td><b>Reference</b></td>
                <td>{formData.reference}</td>
              </tr>
            </tbody>
          </table>

          {/* ITEM TABLE */}
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {[
                    'Sr.No', 'Cloth', 'Delivery Date', 'Rate', 'Qty',
                    'Amount', 'IGST', 'IGST Amt',
                    'CGST', 'CGST Amt', 'SGST', 'SGST Amt'
                  ].map((head, i) => (
                    <TableCell
                      key={i}
                      align="center"
                      sx={{ fontWeight: 'bold', border: '1px solid black', p: 0.5 }}
                    >
                      {head}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {polist?.info?.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{index + 1}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.cloth}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.delivery_date}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.rate}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.mtr}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.Amount}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.igst}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.igstAmt}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.cgst}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.cgstAmt}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.sgst}</TableCell>
                    <TableCell align="center" sx={{ border: '1px solid black', p: 0.5 }}>{row.sgstAmt}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          {/* TOTAL SECTION */}
          <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
            <tbody>
              <tr>
                <td><b>Final Total Qty / Mtr</b></td>
                <td>{formData.tot_mtr}</td>
                <td><b>Final Gross Amt</b></td>
                <td>{formData.amt}</td>
              </tr>
              <tr>
                <td><b>Final GST Amt</b></td>
                <td>{formData.taxAmt}</td>
                <td><b>Final Net Amt</b></td>
                <td>{formData.finalAmt}</td>
              </tr>
            </tbody>
          </table>

          {/* TERMS */}
          <div style={{ marginTop: '15px' }}>
            <b>Terms & Conditions</b>
            <p>Payment Terms: Within 45 to 60 days</p>
          </div>

        </div>

        {/* PRINT BUTTON */}
        <div className="no-print" style={{ marginTop: '15px' }}>
          <ReactToPrint
            trigger={() => <Button variant="contained">Print</Button>}
            content={() => componentRef.current}
          />
        </div>

      </Paper>
    </Grid>
  );
};

export default PurchaseOrdView;